<template>
  <el-date-picker
    class="width-300"
    v-model="date"
    type="daterange"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    value-format="yyyy-MM-dd"
    @change="changeFn"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'FilterDate',
  data() {
    return {
      date: '',
      startDate: '',
      endDate: ''
    };
  },
  methods: {
    changeFn(value) {
      if (value) {
        this.startDate = value[0] + ' 00:00:00';
        this.endDate = value[1] + ' 23:59:59';
      } else {
        this.startDate = '';
        this.endDate = '';
      }
      this.$emit('change', {
        type: 'date',
        value: {
          startDate: this.startDate,
          endDate: this.endDate
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
